export default __webpack_public_path__ + "static/media/ABCD.60ea2e43.jpg";